import { CarLeasingController } from './car-leasing.controller';
import { CarLeasingCatalogController } from './catalog/car-leasing-catalog.controller';
import {CarLeasingCheckoutController} from "./checkout/carleasing_checkout_controller/carleasing_checkout_controller";

angular
  .module( 'VSPApp' )
  .controller( 'CarLeasingCatalogController', CarLeasingCatalogController )
  .controller( 'CarLeasingCheckoutController', CarLeasingCheckoutController )
  .controller( 'CarLeasingController', CarLeasingController );
